import 'bootstrap'
import './sass/main.scss'
import 'select2'
import 'bootstrap-datepicker'
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.ru.min'
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.css'
import 'jquery.maskedinput/src/jquery.maskedinput.js'
import './jquery.bs4-scrolling-tabs'
import './datepicker'
import './datepicker.css'
import 'select2/dist/css/select2.css'
import 'perfect-scrollbar/css/perfect-scrollbar.css'
import 'floating-scroll'
import 'floating-scroll/dist/jquery.floatingscroll.css'
import './responsive-tester.min'
import './jquery.sticky'
//import './scripts'



const moment = require('moment');
global.PerfectScrollbar = require('perfect-scrollbar').default;
global.$ = require("jquery");
global.jQuery = global.$;
